import { jsx as _jsx } from "react/jsx-runtime";
import { getArrayDims } from '@iotv/datamodel-core';
import GoogleIcon from '@mui/icons-material/Google';
import { Button, Stack, Tooltip } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { AppMainViewContext } from '../../../ContextProviders/AppContextProvider';
import { clearSheet, getOrCreateSpreadsheet, updateValues } from '../../../Google/Sheets/sheetFns';
import { rangeFromSheetAndCol, ziToC } from '../sharedFns';
const debug = process.env.REACT_APP_DEBUG && false;
/** Takes any object plus a funtion that will transform to sheets compatible array and exports to an existing or new ss of the same name as the object */
export const RowColumnExport = ({ rowColumnizer, object, spreadsheetTitle }) => {
    const [exportRCs, setExportRCs] = useState(undefined);
    const [spreadsheetUrl, setSpreadheetUrl] = useState(undefined);
    const [{ googleAccessTokenPresent }] = useContext(AppMainViewContext);
    useEffect(() => {
        debug && console.log('RowColumnExport useEffect');
        setExportRCs(rowColumnizer(object));
    }, [object, rowColumnizer, spreadsheetTitle]);
    const handleExport = async () => {
        const getOrCreateRes = await getOrCreateSpreadsheet({ name: spreadsheetTitle });
        if (getOrCreateRes.data) {
            const { spreadsheet, duplicateName } = getOrCreateRes.data;
            const { spreadsheetId, spreadsheetUrl, properties } = spreadsheet ?? {};
            const { title } = properties ?? {};
            if (spreadsheetId && exportRCs) {
                const { rows, cols } = getArrayDims(exportRCs);
                const range = rangeFromSheetAndCol(undefined, 'A', ziToC(cols), 1, rows);
                await clearSheet({ spreadsheetId, range: 'A1:Z5000', valueInputOption: 'USER_ENTERED' }); // TODO: Update placeholder value.: })
                await updateValues({ spreadsheetId, range, valueInputOption: 'USER_ENTERED' }, { majorDimension: 'ROWS', range, values: exportRCs });
                setSpreadheetUrl(spreadsheetUrl ?? `https://docs.google.com/spreadsheets/d/${spreadsheetId}`);
            }
        }
        else {
            console.log(`ERR: ${getOrCreateRes.err?.message}`);
        }
    };
    const signedIn = googleAccessTokenPresent;
    return (_jsx(Stack, { direction: "row", children: _jsx("a", { href: spreadsheetUrl, target: "_blank", rel: "noreferrer", children: _jsx(Tooltip, { title: spreadsheetUrl ? 'Click to view' : signedIn ? `Export to Sheets` : `Not signed in`, arrow: true, children: _jsx("span", { children: _jsx(Button, { variant: 'outlined',
                        color: spreadsheetUrl ? 'success' : signedIn ? 'primary' : 'inherit',
                        size: 'small',
                        disabled: !signedIn,
                        textTransform: 'none',
                        style: { textTransform: 'none' },
                        onClick: handleExport,
                        endIcon: _jsx(GoogleIcon, {}), children: "Export" }) }) }) }) }));
};
